import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { isAndroid } from 'react-device-detect'

import { Icons } from '../../components/Icons'
import Loading from '../../components/Loading'
import '../../onBoardingV2.scss'
import imgLogo from '../../assets/icons/megaGo.svg'
import iconArrowBack from '../../assets/icons/arrowBack.svg'
import badgeIos from '../../assets/img/app-store-badge.png'
import badgeAndroid from '../../assets/img/google-play-badge.png'

const APP_STORE_URL = 'https://apps.apple.com/cl/app/mega-go/id1571743848'
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=cl.megamedia.megago&ah=1BBIBAysiNcshGHuokWDJq1-bXk'
const ANDROID_PACKAGE = 'cl.megamedia.megago'
const ANDROID_HOST = 'megago.cl'
const ANDROID_REDIRECT_SAFETY_TIMEOUT_MS = 4000

// Chrome en iOS y Android comparte la misma protección anti-secuestro: si el click
// ocurre navegando dentro del propio dominio (megago.cl), no dispara el Universal
// Link / App Link automáticamente aunque assetlinks.json/AASA estén bien configurados.
// El botón de la store ya se muestra de entrada; el intento de abrir la app dispara
// el prompt nativo del navegador por encima de esta misma vista.
// - iOS: se intenta el custom URL scheme.
// - Android: se usa el esquema intent:// con browser_fallback_url, que es el mecanismo
//   oficial de Chrome para forzar la apertura de la app o caer a Play Store.
export default function OpenInAppContainer({ isIOS }) {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(isAndroid)

  useEffect(() => {
    if (!isIOS && !isAndroid) return

    if (isIOS) {
      window.location.href = `megago://${pathname}`
    } else {
      const fallbackUrl = encodeURIComponent(PLAY_STORE_URL)
      window.location.href = `intent://${ANDROID_HOST}${pathname}#Intent;scheme=https;package=${ANDROID_PACKAGE};S.browser_fallback_url=${fallbackUrl};end`
    }
  }, [isIOS, pathname])

  useEffect(() => {
    if (!isAndroid) return

    const revealFallback = () => {
      if (!document.hidden) setLoading(false)
    }
    const safetyTimer = setTimeout(revealFallback, ANDROID_REDIRECT_SAFETY_TIMEOUT_MS)

    return () => clearTimeout(safetyTimer)
  }, [])

  if (loading) {
    return <Loading />
  }

  return (
    <div className='obLivesContainer openInApp'>
      <button type='button' className='backButton' onClick={() => navigate('/')}>
        <Icons path={iconArrowBack} />
      </button>
      <Icons path={imgLogo} className='navLogo' />
      <h2>Descarga la app</h2>
      <p>Y disfruta de los mejores programas, teleseries y eventos cuando y donde quieras.</p>
      {isIOS
        ? (
          <a className='badgeLink' href={APP_STORE_URL}>
            <img alt='Descárgalo en el App Store' src={badgeIos} />
          </a>
          )
        : (
          <a className='badgeLink' href={PLAY_STORE_URL}>
            <img alt='Disponible en Google Play' src={badgeAndroid} />
          </a>
          )}
      <p className='disclaimer'>Disponible sólo para Chile.</p>
    </div>
  )
}
